import React from "react";
import Footer from "../components/Footer";
import bandeau_campus_CMH from "../assets/images/bandeau_campus_CMH.png";
import { generateCalendarEvent } from "../utils/calendarUtils";

const AgendaPage: React.FC = () => {
  const eventDetails = {
    title:
      'Event "Cardiomyopathies hypertrophiques sarcomériques : l\'imagerie pour optimiser la prise en charge"',
    description: "",
    startDate: new Date("2025-11-04T20:00:00"),
    endDate: new Date("2025-11-04T21:00:00"),
    location: "",
    organizer: "",
    url: "",
  };

  const handleAddToCalendar = (format: "google" | "outlook" | "ics") => {
    try {
      const calendarUrl = generateCalendarEvent(eventDetails, format);

      if (format === "ics") {
        // For ICS files, create a download link
        const link = document.createElement("a");
        link.href = calendarUrl;
        link.download = "event.ics";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        // For Google Calendar and Outlook, open in new tab
        window.open(calendarUrl, "_blank");
      }
    } catch (error) {
      console.error("Error adding to calendar:", error);
    }
  };

  return (
    <div>
      <img src={bandeau_campus_CMH} alt="Banner" className="banner" />
      <div className="ContainerV2">
        <div className="ContainerV2In2">
          <div className="agenda-container">
            <div className="titleInscription">
              <div className="title1">AGENDA</div>
            </div>

            <div className="event-details">
              <h2>{eventDetails.title}</h2>

              <div className="event-info">
                <div className="info-item">
                  <strong>📅 Date :</strong> Mardi 4 novembre 2025
                </div>
                <div className="info-item">
                  <strong>🕐 Heure :</strong> 20h00 - 21h00 (UTC+2)
                </div>
              </div>

              <div className="calendar-actions">
                <h3>Ajouter à votre calendrier :</h3>
                <div className="calendar-buttons">
                  <button
                    className="calendar-btn google-btn"
                    onClick={() => handleAddToCalendar("google")}
                  >
                    📅 Google Calendar
                  </button>
                  <button
                    className="calendar-btn outlook-btn"
                    onClick={() => handleAddToCalendar("outlook")}
                  >
                    📅 Outlook
                  </button>
                  <button
                    className="calendar-btn apple-btn"
                    onClick={() => handleAddToCalendar("ics")}
                  >
                    📱 iPhone Calendar
                  </button>
                  <button
                    className="calendar-btn other-btn"
                    onClick={() => handleAddToCalendar("ics")}
                  >
                    📅 Autres calendriers
                  </button>
                  <button
                    className="calendar-btn ics-btn"
                    onClick={() => handleAddToCalendar("ics")}
                  >
                    📥 Télécharger (.ics)
                  </button>
                </div>
              </div>

              <div className="bottomInscription">
                <div className="CONTACT">
                  Pour toute question, nous vous invitons à contacter
                  l'assistance : <br /> Adresse email :{" "}
                  <a href="mailto:cmho@henri8.com" style={{ color: "#AA3F87" }}>
                    cmho@henri8.com{" "}
                  </a>{" "}
                  ou téléphone :{" "}
                  <a href="tel:+33144900059" style={{ color: "#AA3F87" }}>
                    +33 1 44 90 00 59
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AgendaPage;
